import { SyncOutlined } from '@ant-design/icons';
import { Button, Layout, Result } from 'antd';
import { useTranslation } from 'react-i18next';

const AppUpdatedPage = () => {
  const { t } = useTranslation();

  return (
    <Layout className="min-h-screen w-full flex items-center justify-center">
      <Result
        icon={<SyncOutlined style={{ color: '#1677ff' }} />}
        title={t('errors.pages.app_updated.title')}
        subTitle={t('errors.pages.app_updated.message')}
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            {t('errors.pages.app_updated.reload')}
          </Button>
        }
      />
    </Layout>
  );
};

export default AppUpdatedPage;
